import axios from 'axios';
import routes from '../utils/routes';

if (document.getElementById('js-resend-dropdown')) {
  const resendButton = document.getElementById('js-resend-dropdown');
  const currentTfaMethodElement = document.getElementById('currentTfaMethod');
  let countdown = 60;

  const startCountdownTimer = () => {
    setTimeout(() => {
      if (countdown > 0 && resendButton instanceof HTMLElement) {
        resendButton.innerHTML = `Resend Code (${countdown})`;
        resendButton.setAttribute('disabled', 'true');
        countdown -= 1;
        setTimeout(startCountdownTimer, 500); // 500 * 2 = 1000
      } else if (resendButton instanceof HTMLElement) {
        countdown = 60;
        resendButton.innerHTML = 'Resend Code';
        resendButton.removeAttribute('disabled');
      }
    }, 500); // 500 * 2 = 1000
  };

  startCountdownTimer();

  document.querySelectorAll('a.resend-tfa-button')
    .forEach((button) => button.addEventListener('click', (e) => {
      e.preventDefault();
      startCountdownTimer();

      axios.post(routes.TFA_RESEND_CODE, {
        // @ts-ignore
        method: e.target.getAttribute('data-method'),
      })
        .then((response) => {
          if (response.data.success) {
            // @ts-ignore
            currentTfaMethodElement.innerHTML = e.target.getAttribute('data-method');
          }
        });
    }));
}
